var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInverted11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 98,
    viewBox: "0 0 142 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 60C80 49.6 81.6 40.6667 84.8 33.2C88 25.4667 92.1333 19.2 97.2 14.4C102.267 9.33334 108 5.73334 114.4 3.6C121.067 1.2 127.6 0 134 0V14C127.067 14 120.533 16.4 114.4 21.2C108.533 25.7333 105.067 32 104 40C104.8 39.7333 105.733 39.4667 106.8 39.2C107.6 38.9333 108.533 38.6667 109.6 38.4C110.933 38.1333 112.4 38 114 38C122 38 128.667 41.0667 134 47.2C139.333 53.0667 142 60 142 68C142 76 139.2 83.0667 133.6 89.2C128.267 95.0667 121.067 98 112 98C101.867 98 94 94.2667 88.4 86.8C82.8 79.0667 80 70.1333 80 60ZM0 60C0 49.6 1.6 40.6667 4.8 33.2C8 25.4667 12.1333 19.2 17.2 14.4C22.2667 9.33334 28 5.73334 34.4 3.6C41.0667 1.2 47.6 0 54 0V14C47.0667 14 40.5333 16.4 34.4 21.2C28.5333 25.7333 25.0667 32 24 40C24.8 39.7333 25.7333 39.4667 26.8 39.2C27.6 38.9333 28.5333 38.6667 29.6 38.4C30.9333 38.1333 32.4 38 34 38C42 38 48.6667 41.0667 54 47.2C59.3333 53.0667 62 60 62 68C62 76 59.2 83.0667 53.6 89.2C48.2667 95.0667 41.0667 98 32 98C21.8667 98 14 94.2667 8.4 86.8C2.8 79.0667 0 70.1333 0 60Z",
    fill: "url(#paint0_linear_1_9266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9266",
    x1: 71,
    y1: 0,
    x2: 71,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverted11);
export default __webpack_public_path__ + "static/media/inverted 1 (1).767def7e54d25e655de0916740462b88.svg";
export { ForwardRef as ReactComponent };